<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_4"></a>
<p class="copyt">First published in 1989 by Hodder and Stoughton</p>
<p class="copy">This digital edition first published in 2014 by Canongate Books, 14 High Street, Edinburgh EH1 1TE</p>
<p class="copy">Copyright © William McIlvanney 1989</p>
<p class="copy">The moral right of the author has been asserted</p>
<p class="copy">All characters in this publication are fictitious and any resemblance
to real persons, living or dead, is purely coincidental.</p>
<p class="copy"><i>British Library Cataloguing in Publication Data</i><br/>
A catalogue record for this book is available on<br/>
request from the British Library</p>
<p class="copy">ISBN 978 1 78211 194 8</p>
<p class="copy"><a href="http://www.canongate.tv" target="_blank">www.canongate.tv</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Copyright.vue?d0063de6